jQuery(function ($) {
    initMagnificPopup();
    initJWAccordions();
    initEcologiPageNumber();
  
    jwAlignMenu();
    jQuery(window).on('resize', function() {
        jwAlignMenu();
    });
});


function initMagnificPopup() {
    $('.iframe').magnificPopup({
        type: 'iframe'
    });
    $('.open-popup-link').magnificPopup({
        type:'inline',
        midClick: true,
        callbacks:{
            open: function(){
                var jwEcologiEl = $('#jwEcologiPopup');
              
                if (jwEcologiEl.length != 0) {
                    getEcologiNumber();
                }
            }
        }
      });
}

function initJWAccordions() {
    $('.jw-text-accordions-heading').on('click', function () {
        $(this).siblings('.jw-text-accordions-body').toggleClass('active');
    });
}
function initEcologiPageNumber(){
    var jwEcologiPage = $('.jw-ecologi-widget-popup-icon');
    if (jwEcologiPage.length != 0) {
        getEcologiNumber();
    }
}
function getEcologiNumber(){
    $.get("https://public.ecologi.com/users/needwipes/impact", function (data) {
        var tonStarter = 0;
        var treeStarter = 0;

        var intervalTon = setInterval(function() {
            $('#jwEcologiTon').text(tonStarter);
            if (tonStarter == data.carbonOffset) clearInterval(intervalTon);
            tonStarter++;
        }, 100);

        var intervalTree = setInterval(function() {
            $('#jwEcologiTree').text(treeStarter);
            if (treeStarter == data.trees) clearInterval(intervalTree);
            treeStarter++;
        }, 5);
    });
}

function jwAlignMenu() {
    if( jQuery(window).width() > 768 ) {
      var menuPos = jQuery('.site-nav.site-navigation li').first().position();
      $( '.site-nav.site-navigation li' ).each(function( index ) {
        //console.log( index + ": " + $( this ).text() );
          if( jQuery(window).width() > 993 ) {
              jQuery('.site-nav.site-navigation li').find('ul.jw-mega-menu-panel').css('width', 'calc(100% - '+menuPos.left+'px)');
          }
          else
              jQuery('.site-nav.site-navigation li').find('ul.jw-mega-menu-panel').css('width', 'calc(75% - 9px)');

      });
    }
}